import resolveAppUrl from "utils/resolveAppUrl";

const EMBER_HOST = import.meta.env.VITE_EMBER_HOST;

export const getEmberPath = (url = "") => resolveAppUrl(window.location.origin, EMBER_HOST) + url;
